import { Skeleton } from '@mantine/core';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface DeploymentSummaryProps {
    isLoading?: boolean;
    cloudComputes?: number;
    bareMetalComputes?: number;
    containerEngines?: number;
    hostings?: number;
}

const DEPLOYMENT_ITEMS = [
    { labelKey: 'deploymentSummary.cloudComputes', key: 'cloudComputes' },
    { labelKey: 'deploymentSummary.bareMetalComputes', key: 'bareMetalComputes' },
    { labelKey: 'deploymentSummary.containerEngines', key: 'containerEngines' },
    { labelKey: 'deploymentSummary.hostings', key: 'hostings' },
] as const;

function DeploymentSummary({
    isLoading = false,
    cloudComputes = 0,
    bareMetalComputes = 0,
    containerEngines = 0,
    hostings = 0,
}: DeploymentSummaryProps) {
    const { t } = useTranslation('dashboard');

    const values = {
        cloudComputes,
        bareMetalComputes,
        containerEngines,
        hostings,
    };

    return (
        <div className="w-full flex flex-col justify-start items-start gap-1 overflow-hidden">
            <h2 className="text-xl">{t('deploymentSummary.title')}</h2>
            <p className="text-sm text-fg/68">{t('deploymentSummary.subtitleLong')}</p>
            <div className="mt-4 w-full grid grid-cols-2 gap-4">
                {DEPLOYMENT_ITEMS.map((item) => (
                    <div
                        key={item.key}
                        className="flex flex-col justify-start items-start border-b-[0.5px] border-line"
                    >
                        <h3 className="text-fg/78">{t(item.labelKey)}</h3>
                        {isLoading ? (
                            <Skeleton className="mt-1.5 mb-2.5" height={28} width={'100%'} />
                        ) : (
                            <div className="mb-2.5 font-bold text-fg">{values[item.key]}</div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default memo(DeploymentSummary);
